import { h, Component } from "preact";
import $ from "jquery";
import GlobState from 'globstate'
import Globals from '../globals.js'
import $ti from '../ti.js'

import * as _ from "../components/index.js";

class favsView extends Component {
  constructor(props) {
    super(props);
    let questionId = parseInt(props.id);
    let templates = Globals.Templates();

    let usedExp = {}
    let answers = {}
    let myFavs = {}
    myFavs[questionId] = 1

    this.state = {
      templates: templates,
      questions: [this.findQuestion(questionId,templates)],
      answers: answers,
      usedExp: usedExp,
      favs: myFavs,
      activeQuestion: 0,
      lang: props.app.lang,
    };
  }

  findQuestion(id,templates) {
    let rt = [];
    let finded = false;
    for(let i = 0; i < Object.keys(templates).length; i++){
      let template = templates[i];
      for (var m = 0; m < template.questions.length; m++) {
        let question = template.questions[m];
        if(question.id == id){
          rt = question;
          finded = true;
          break;
        }
      }
      if(finded){
        break;
      }
    }
    return rt;
  }

  showExp = (e) => {
    $('.questionExp').removeClass('d-none');

    let exp = this.state.usedExp;

    let t = $(e.target).closest('.idea');
    let questionId = parseInt(t.attr('rel'));
    if (!exp) {
      exp = {}
    }
    exp[questionId] = 1;

    this.setState({
      usedExp: exp
    })

  }

  setAnswer = (e) => {

    let answers = this.state.answers;

    let t = $(e.target);
    let questionId = parseInt(t.attr('rel'));
    let answerId = parseInt(t.val());

    if (!answers) {
      answers = {}
    }

    answers[questionId] = answerId;

    let isCorrect = false;
    
    let idx = this.state.questions.findIndex(x => x.id == questionId);
    let idxA = this.state.questions[idx].answers.findIndex(x => x.id == answerId);

    if (this.state.questions[idx].answers[idxA].isCorrect) {
      isCorrect = true;
    }

    this.setState({
      answers: answers,
      isCorrect: isCorrect,
    })
  }

  addFav = (e) => {
    let t = $(e.target);
    let questionId = parseInt(t.attr('rel'));
    let templateId = parseInt(t.attr('data-template'));
    let data = JSON.parse(localStorage.getItem('favs_' + templateId))


    if (!data) {
      data = {}
    }
    data[questionId] = 1

    this.setState({
      favs: data
    })

    localStorage.setItem('favs_' + templateId, JSON.stringify(data));
    $('#add_favorite_item').parent().find('.btn-secondary').click();
  }

  delFav = (e) => {
    let t = $(e.target);
    let questionId = parseInt(t.attr('rel'));
    let templateId = parseInt(t.attr('data-template'));
    let data = JSON.parse(localStorage.getItem('favs_' + templateId))
    if (data) {
      if (data[questionId]) {
        delete data[questionId];
        this.setState({
          favs: data
        })
      }
    }
    localStorage.setItem('favs_' + templateId, JSON.stringify(data));
    $('#del_favorite_item').parent().find('.btn-secondary').click();
  }

  render() {
    let lang = this.state.lang
    
    let question = this.state.questions[0];
    let image = question ? question.image : null;
    let answers = question ? question.answers : null;
    let isFav = this.state.favs[question.id] ? true : false;
    let correctAnswer;
    let displayExp = 'd-none';
    let displayExpIcon = '';
    let exp = this.state.usedExp ? this.state.usedExp : {}

    return (
      <>

        <section class="header">

          <div class="header_menu">
            <div class="d-flex align-items-center">
              <a href='/fav/' class="mx-2" type="button"><i class="demo-icon icon-angle-left"></i></a>
              <span class="ms-2">Шаблон {this.state.templates[(parseInt(question.templateId) -1)].title} / Вопрос {question.ord}</span>
            </div>
            <div class="d-flex align-items-center">
              {!isFav ?
                <a href="#" class="mx-2" type="button" data-bs-toggle="modal" data-bs-target="#add_favorite_item">
                  <i class="demo-icon icon-heart-empty-1 red_icon"></i>
                </a>
                :
                <a href="#" class="mx-2" data-bs-toggle="modal" data-bs-target="#del_favorite_item">
                  <i class="demo-icon icon-heart-1 red_icon"></i>
                </a>
              }

            </div>
          </div>

        </section>

        <section class="menu menu_test" style="padding-top: 75px;">

          <div class="quest">
            {(image ? <img src={image} alt="" class="quest_img" /> : null)}
            <span class="font_bold">Вопрос:</span>
            <span class="" dangerouslySetInnerHTML={{__html: question.question[lang]}}></span>
          </div>

          <div class="my-2">
            {Object.keys(answers).map((tmp) => {
              var isChecked = false;
              var isCorrect = false;
              var className = 'false';

              if (answers[tmp]['isCorrect']) {
                correctAnswer = answers[tmp][lang]
                exp = answers[tmp]['exp'][lang]
                isCorrect = true;
                className = 'true';
              } 
              
              if (this.state.answers && this.state.answers[question.id]) {

                if (isCorrect && this.state.answers[question.id] != answers[tmp]['id']) {
                  className = 'bg-success';
                } else {
                  displayExp = '';
                  displayExpIcon = 'd-none';
                }
              }

              if (this.state.answers && this.state.answers[question.id] == answers[tmp]['id']) {
                isChecked = true;
              } else {
                if (isCorrect) {
                  if (this.state.usedExp && this.state.usedExp[question.id]) {
                    className = 'bg-success';
                    displayExp = '';
                    displayExpIcon = 'd-none';
                  }
                }
              }

              return <span>
                <input type="radio" class={className} id={`answer_${answers[tmp]['id']}`} rel={question.id} name={`answer`} value={answers[tmp]['id']} data-isCorrect={answers[tmp]['isCorrect']} onClick={this.setAnswer} checked={isChecked} />
                <label for={`answer_${answers[tmp]['id']}`}>{answers[tmp][lang]}</label>
              </span>
            })}
          </div>

          <div class={`d-flex flex-column questionExp ${displayExp}`}>
            <span class="font_bold">Правильный ответ:</span>
            <span class="mt-1">{correctAnswer}</span>
            <span class="font_bold mt-3">Комментарий:</span>
            <span class="mt-1" dangerouslySetInnerHTML={{
              __html: exp
            }}></span>

            <a class="btn btn-light mt-3" onClick={this.showErrorModal} href="javascript:void(0)" role="button">Сообщить об ошибке</a>
          </div>

          <a href="javascript:void(0)" onClick={this.showExp} rel={question.id} class={`idea ${displayExpIcon}`}><i class="demo-icon icon-lightbulb-1"></i></a>
        </section>
        {console.log(question.templateId)}
        <div class="modal fade" id="add_favorite_item" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="d-flex flex-column align-items-center">
                  <span class="mb-3 font20">Добавить в избранное?</span>
                  <div>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Отмена</button>
                    <button type="button" class="btn btn-success mx-3" rel={question.id} data-template={question.templateId} onClick={this.addFav}>Добавить</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade" id="del_favorite_item" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="d-flex flex-column align-items-center">
                  <span class="mb-3 font20">Удалить вопрос из избранного?</span>
                  <div>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Отмена</button>
                    <button type="button" class="btn btn-danger mx-3" rel={question.id} data-template={question.templateId} onClick={this.delFav}>Удалить</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </>
    );
  }
}

export default GlobState.connect(favsView, Globals)